import gql from "graphql-tag";
import {client} from "./client";
import {AllContactsWithEntity} from "../../schema/AllContacts";
import {Contact, ContactsConnection, Query} from "../../types";
import Maybe from "graphql/tsutils/Maybe";

/**
 *
 * TODO: use paging
 *
 * */

export async function requestContacts ():
    Promise<Array<Contact>> {
    try {
        const result: {data: Query} = await client.query({
            query: gql`${AllContactsWithEntity}`
        });
        const allContacts = result.data.allContacts
        return allContacts ? mapNodes(allContacts!) : [];
    } catch (e) {
        return [];
    }
}

function getName(node: Maybe<Contact>) {
    try {
        return node!.entitycontactsByPocid?.nodes[0]?.entityByFullUid?.name;
    } catch (e) {
        console.warn(e);
        return '';
    }
}

function mapNodes(allContacts: ContactsConnection): Contact[] {
    return allContacts.nodes.map(
        node => ({
            ...node,
            entityName: getName(node)
        } as Contact & {entityName: string})
    );
}
